import { Component, OnDestroy, OnInit } from "@angular/core";
import { WebCustomerAgingVariables, WebCustomer } from "../../../models";
import { Subscription } from "rxjs";
import { CustomerService, SharedService } from "../../../services";

import { filter } from "rxjs/operators";
export interface Balances
{
  balType: string;
  balAmount: number;
  color?: string;
}


@Component({
  selector: "app-customer-aging-dialog",
  templateUrl: "./customer-aging-dialog.component.html",
  styleUrls: ["./customer-aging-dialog.component.scss"],
})
export class CustomerAgingDialogComponent implements OnInit, OnDestroy
{
  bucketBalances: Balances[];
  balances: Balances[];
  amountDueColor: string;
  customerSubscription: Subscription;
  customer: WebCustomer;
  customerAgingSubscription: Subscription;
  customerAging: WebCustomerAgingVariables;
  displayedColumns: string[] = ["balType", "balAmount"];
  filteredBalances: Balances[];
  constructor(public customerService: CustomerService, private sharedService: SharedService) { }

  ngOnInit(): void {
    this.customerSubscription = this.customerService.customer.subscribe(customer =>
    {
      this.customer = customer;
    });


    this.customerAgingSubscription = this.customerService.customerAging.subscribe(customerAging =>
    {
      this.customerAging = customerAging;
    });
    this.initializeBucketBalances();
    this.updateOtherBalances();
    this.setColorBasedOnBalType();
  }

  private initializeBucketBalances(): void
  {
    this.bucketBalances = [
      { balType: "Pending", balAmount: this.customerAging.Pending },
      { balType: "New Finance Charge", balAmount: this.customer.NewFc },
      { balType: "Unpaid Finance Charge", balAmount: this.customer.UnpaidFc },
      { balType: "Current", balAmount: this.customerAging.CurrBucket },
      {
        balType: this.customerAging.Over30BucketDescription || "Over 30",
        balAmount: this.customerAging.Over30Bucket,
      },
      {
        balType: this.customerAging.Over60BucketDescription || "Over 60",
        balAmount: this.customerAging.Over60Bucket,
      },
      {
        balType: this.customerAging.Over90BucketDescription || "Over 90",
        balAmount: this.customerAging.Over90Bucket,
      },
      {
        balType: this.customerAging.Over120BucketDescription || "Over 120",
        balAmount: this.customerAging.Over120Bucket,
      },
    ];
  }

  private updateOtherBalances(): void
  {
    this.balances = [];

    if (this.customer.ContractBal > 0)
    {
      this.balances.push({
        balType: "Contract Balance",
        balAmount: this.customer.ContractBal,
      });
    }
    if (this.customer.IsBudget)
    {
      if (this.customer.NonBudBal > 0)
      {
        this.balances.push({
          balType: "Non Budget Balance",
          balAmount: this.customer.NonBudBal,
        });
      }
      this.balances.push({
        balType: "Budget Balance",
        balAmount: this.customer.BudBal,
      });
    }
    this.filteredBalances = this.balances.filter((balance) =>
    {
      return !(balance.balType === "Budget Balance" && !this.customer.IsBudget);
    });
  }

  private setColorBasedOnBalType(): void
  {
    if (this.customer.IsBudget)
    {
      const budgetColor = this.getBudgetBalanceColor();
      this.balances.forEach((balance) =>
      {
        if (balance.balType === "Budget Balance")
        {
          balance.color = budgetColor;
        }
      });
    }
    else
    {
      this.amountDueColor = this.customerAging.DisplayBalanceColorHex;
      if (this.amountDueColor === "#FFFFFF" && !this.sharedService.isDark)
      {
        this.amountDueColor = "";
      }
    }
  }

  private getBudgetBalanceColor(): string
  {
    const hex = this.customerAging.DisplayBalanceColorHex;
    if (this.customerAging.BudgetOver120 > 0)
      return hex || "red";
    if (this.customerAging.BudgetOver90 > 0)
      return hex || "darkorange";
    if (this.customerAging.BudgetOver60 > 0)
      return hex || "gold";
    if (this.customerAging.BudgetOver30 > 0 || this.customerAging.BudgetCurrent > 0)
      return hex || "green";

    return "primary";
  }

  hasBalances(): boolean
  {
    return (
      this.filteredBalances.length > 0 &&
      this.filteredBalances.some((b) => b.balAmount != null)
    );
  }

  ngOnDestroy()
  {
    this.customerAgingSubscription.unsubscribe();
    this.customerSubscription.unsubscribe();
  }
}
